import moment from "moment";

import { FlatLookupView } from "@/Common/Api/MedfarDictionaries/Dto/Responses/FlatLookupView";

class QuestionnaireLinkConfiguration {
    public static shouldLinkBeActive(
        appointmentDate: Date,
        appointmentStatusLookupId: string,
        hasQuestionnaireSubmitted: boolean,
        patientId: string,
        isPortalPatient: boolean,
        questionnaireInstanceId: string
    ): boolean {
        const hasValidPatient: boolean = !isGuidNullOrUndefinedOrEmpty(patientId) || isPortalPatient;

        const cancelledLookup: FlatLookupView = cacheStore.FindLookupByLookupCode("CANCELED", "SITEMGMT.APPOINTMENTS.STATE");
        const cancelledByPatientLookup: FlatLookupView = cacheStore.FindLookupByLookupCode("CANCELLED BY PATIENT", "SITEMGMT.APPOINTMENTS.STATE");
        const isCancelled: boolean = appointmentStatusLookupId == cancelledLookup.LookupID || appointmentStatusLookupId == cancelledByPatientLookup.LookupID;

        if (!appointmentDate || !hasValidPatient || (isCancelled && !hasQuestionnaireSubmitted) || isGuidNullOrUndefinedOrEmpty(questionnaireInstanceId))
            return false;

        const currentDate = moment();
        const oneDayBeforeAppointment = moment(appointmentDate).add(-1, "day");
        if (currentDate.isBefore(oneDayBeforeAppointment, "day"))
            return false;

        return hasQuestionnaireSubmitted
            || currentDate.isSame(oneDayBeforeAppointment, "day")
            || currentDate.isSame(appointmentDate, "day");
    }
}

export { QuestionnaireLinkConfiguration };
